<template>
  <div>
    <!-- 内容列表对话框 -->
    <el-dialog title="内容选择" :visible.sync="dialogVisible" :modal-append-to-body="true" append-to-body close-on-click-modal
      width="40%" @closed="handleClose">
      <div class="search-flex">
        <div>
          <el-input size="small" v-model="searchParams.title" placeholder="内容标题" style="width: 200px"></el-input>
          <el-select
            v-model="selectMediaType"
            style="width: 200px; margin-left: 20px"
            clearable
            placeholder="内容类型"
            size="small"
          >
            <el-option label="影视资源" :value="1"></el-option>
            <el-option label="乐播媒资" :value="3"></el-option>
          </el-select>
        </div>
        <el-button type="primary" size="small" @click="search">搜索</el-button>
      </div>
      <el-table ref="multipleTable" :data="list" tooltip-effect="dark" style="margin-top: 20px" height="500" row-key="id"
        @select="selectionChange" @select-all="selectAll">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="ID" prop="id"> </el-table-column>
        <el-table-column label="内容标题" prop="title"> </el-table-column>
        <el-table-column label="内容图片" prop="coverImg">
          <template slot-scope="{ row }">
            <el-image v-if="row.coverImg" style="width: 100px; height: 100px" :src="row.coverImg"
              fit="scale-down"></el-image>
            <span v-else>暂无图片</span>
          </template>
        </el-table-column>
        <el-table-column label="播放来源" prop="thirdPartyAppName">
        </el-table-column>

        <el-table-column label="热度值" prop="hotScore"> </el-table-column>
        <el-table-column label="标签" prop="tags"> </el-table-column>
        <el-table-column label="描述" prop="description"> </el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="{ row }">
            <span v-if="row.status === 1">上架</span>
            <span v-else-if="row.status === 0">下架</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <ElementPagination style="margin-bottom: 20px" :current-page="searchParams.current" :page-size="searchParams.size"
        :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
      <!-- 保存和取消 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button type="primary" size="small" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
import { getContentList } from "@/api/apps/appCard";
export default {
  name: "WebSaaSMultipleCards",
  components: {
    ElementPagination,
  },
  data() {
    return {
      /** 对话框是否可见 */
      dialogVisible: false,
      /** 搜索参数 */
      searchParams: {
        current: 1,
        size: 10,
        total: 0,
        title: ""
      },
      // 搜索下拉筛选框：默认 4:乐播媒资+影视资源
      selectMediaType: undefined,
      list: [],
      /** 选中的ids */
      selectIds: [],
      /** 选中的items */
      selectItems: [],
      /** 来源 */
      source: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 保存的事件 */
    save() {
      console.log("save", this.selectIds);
      const res = [...this.selectItems];
      console.log("res", res);
      /** 24-0325-闪投卡片二期 榜单卡片选择内容列表不能超过五个 */
      if (this.source === 'listForm') {
        if (res.length > 5) {
          Message.error("超过5个媒资，无法提交");
          return;
        }
      }
      this.$emit("save", res);
      this.hide();
    },
    /** 选择的事件 */
    selectionChange(val, row) {
      console.log("", val, row);
      /** 判断id是否在selectIds中 */
      const index = this.selectIds.findIndex((id) => id === row.id);
      if (index !== -1) {
        // 如果存在，就删除
        this.selectIds.splice(index, 1);
        const itemIndex = this.selectItems.findIndex(
          (item) => item.id === row.id
        );
        if (itemIndex !== -1) {
          this.selectItems.splice(itemIndex, 1);
        }
      } else {
        // 如果不存在，就添加
        this.selectIds.push(row.id);
        this.selectItems.push(row);
      }
    },
    /** 全选的事件 */
    selectAll(val) {
      console.log("全选的事件", val);
      if (val) {
        this.selectIds = [];
        val.forEach((item) => {
          this.selectIds.push(item.id);
        });
        this.selectItems = [];
        val.forEach((item) => {
          this.selectItems.push(item);
        });
      } else {
        this.selectIds = [];
        this.selectItems = [];
      }
    },
    show(row, source) {
      console.log("show", row);
      console.log("调用来源", source);
      this.source = source || null
      if (row) {
        row.forEach((item) => {
          this.selectIds.push(item.id);
          this.selectItems.push(item);
        });
      }
      console.log("this.selectIds", this.selectIds);
      this.selectMediaType = undefined;
      this.getList();
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
      this.selectIds = [];
      this.selectItems = [];
      this.source = null
    },
    //^ ^--------------分页相关-------------^ ^
    /** 搜索 */
    async search() {
      this.searchParams.current = 1;
      /** 更新数据 */
      this.getList();
      Message.success("搜索成功");
    },
    /** 分页 */
    async getList() {
      console.log("getList", this.selectMediaType);
      this.searchParams.type = this.selectMediaType ? this.selectMediaType : 4
      /** 请求数据 */
      const { data } = await getContentList(this.searchParams);
      console.log("分页的响应", data);
      this.list = data.data.records;
      this.searchParams.total = data.data.total;
      /** 回填选中态 */
      this.$nextTick(() => {
        this.list.forEach((item) => {
          if (this.selectIds.includes(item.id)) {
            console.log("回填选中态", item);
            this.$refs.multipleTable.toggleRowSelection(item, true);
          }
        });
      });
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
